<app-popup-layout #modal>
  <div class="modal-container py-5 px-4">
    <section class="title">
      <p class="m-0 p-0">Welcome,</p>
      <p>{{ userService?.currentUser?.companyName }}</p>
      <p class="sub-title mt-4">
        Complete below steps to setup your “Meal Card” account
      </p>
    </section>
    <div class="stepper ms-3 mt-3">
      <!-- completed -->
      <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class="line"></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 created-title">Meal Card Account</p>
          <p class="created-sub-title">Your Meal Card account is created.</p>
        </div>
      </div>

      <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class="line"></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 content-title">Account Balance</p>
          <p class="content-subtitle">Your Meal Account balance is 0.00</p>
        </div>
      </div>

      <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class="line"></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 content-title">Employees</p>
          <p class="content-subtitle">
            Add Employees whom you want to allocate meal cards
          </p>
        </div>
      </div>

      <div class="step m-0 p-0">
        <div class="v-stepper">
          <div class="circle mt-4"></div>
          <div class=""></div>
        </div>

        <div class="content ms-3">
          <p class="m-0 p-0 content-title">Meal Allowance</p>
          <p class="content-subtitle">
            On Meal Card allocation, Employee receives automatic alerts
          </p>
        </div>
      </div>
    </div>

    <section class="d-flex justify-center">
      <!-- <button
        mat-flat-button
        color="accent"
        class="me-4"
        (click)="modal.dismiss()"
      >
        I’ll do it Later
      </button> -->

      <button
        mat-flat-button
        color="primary"
        (click)="onSettingUp(); modal.dismiss()"
      >
        Okay
      </button>
    </section>
  </div>
</app-popup-layout>
